"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const bullet_list_1 = require("./bullet-list");
const index_1 = require("./index");
const ordered_list_1 = require("./ordered-list");
const paragraph_1 = require("./paragraph");
class ListItem {
    constructor() {
        this.content = new index_1.ContentNode('listItem');
    }
    paragraph() {
        return this.content.add(new paragraph_1.Paragraph());
    }
    bulletList() {
        return this.content.add(new bullet_list_1.BulletList());
    }
    orderedList() {
        return this.content.add(new ordered_list_1.OrderedList());
    }
    toJSON() {
        return this.content.toJSON();
    }
}
exports.ListItem = ListItem;
//# sourceMappingURL=list-item.js.map